// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ek-0";
export var actionModalContentContainer = "_ek-1";
export var createTagButton = "_ek-2";
export var footerContainer = "_ek-7";
export var fullWidthDivider = "_ek-3";
export var hasCreateTagButton = "_ek-4";
export var noCreateTagButton = "_ek-5";
export var tagsContainer = "_ek-6";
export var tagsModalContentContainer = "_ek-8";